"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React);

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), n.forEach(function (t) {
      _defineProperty(e, t, r[t]);
    });
  }

  return e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      i = Object.keys(e);

  for (n = 0; n < i.length; n++) {
    r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
  }

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (n = 0; n < a.length; n++) {
      r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = new Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }
}

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var err = function err() {
  return console.error("Provider is not initialized yet");
},
    Prevent = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return _inherits(t, React.PureComponent), _createClass(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e._children,
          r = _objectWithoutProperties(e, ["_children"]);

      return t()(r);
    }
  }]), t;
}(),
    initStore = function initStore(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  var o,
      i,
      a = [],
      c = React.createContext(),
      u = function u(e, t, r) {
    a.forEach(function (n) {
      return n(e, t, r);
    }), o.setState(t, function () {
      return i.forEach(function (t) {
        return t(e, r);
      });
    });
  },
      s = Object.keys(e.actions).reduce(function (t, r) {
    return _objectSpread({}, t, _defineProperty({}, r, function () {
      for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
        n[i] = arguments[i];
      }

      if (o) {
        var a,
            c = (a = e.actions)[r].apply(a, [o.state].concat(n));
        c.then ? c.then(function (e) {
          return u(r, e, n);
        }) : u(r, c, n);
      } else err();
    }));
  }, {}),
      l = function (e) {
    function t() {
      var e, r, n;

      _classCallCheck(this, t);

      for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return _possibleConstructorReturn(n, (r = n = _possibleConstructorReturn(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(i))), Object.defineProperty(_assertThisInitialized(n), "_children", {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        value: function value() {
          return n.props.children;
        }
      }), Object.defineProperty(_assertThisInitialized(n), "prevent", {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        value: function value(e) {
          var t = e.state,
              r = e.actions,
              o = n.props,
              i = o.mapStateToProps,
              a = (o.children, _objectWithoutProperties(o, ["mapStateToProps", "children"]));
          return React__default.createElement(Prevent, _extends({}, i(t), a, {
            actions: r,
            _children: n._children
          }));
        }
      }), r));
    }

    return _inherits(t, React.Component), _createClass(t, [{
      key: "render",
      value: function value() {
        return React__default.createElement(c.Consumer, null, this.prevent);
      }
    }]), t;
  }();

  return {
    Provider: function (t) {
      function n() {
        var t;
        return _classCallCheck(this, n), t = _possibleConstructorReturn(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this)), o = _assertThisInitialized(t), t.state = e.initialState, i = r.map(function (t) {
          return t(e, o, s);
        }), t.value = {
          actions: s,
          state: t.state
        }, t;
      }

      return _inherits(n, React.Component), _createClass(n, [{
        key: "render",
        value: function value() {
          return this.state !== this.value.state && (this.value = {
            actions: s,
            state: this.state
          }), React__default.createElement(c.Provider, {
            value: this.value
          }, this.props.children);
        }
      }]), n;
    }(),
    Consumer: l,
    actions: s,
    getState: function getState() {
      return o ? o.state : err();
    },
    connect: function connect(e) {
      return function (t) {
        var r = function r(_r) {
          return React__default.createElement(l, _extends({
            mapStateToProps: e
          }, _r), function (e) {
            return React__default.createElement(t, e);
          });
        };

        return r.displayName = "Connect(".concat(t.displayName || t.name || "Unknown", ")"), r;
      };
    },
    subscribe: function subscribe(e) {
      a = _toConsumableArray(a).concat([e]);
    },
    unsubscribe: function unsubscribe(e) {
      a = a.filter(function (t) {
        return t !== e;
      });
    }
  };
};

exports.initStore = initStore;